import { Cryptocurrency, Exchange } from '../types'

export const cryptocurrencies: Cryptocurrency[] = [
  {
    id: 'bitcoin',
    name: 'Bitcoin',
    symbol: 'BTC',
    rank: 1,
    trustScore: 9.5,
    price: 43250.0,
    marketCap: 846000000000,
    volume24h: 28500000000,
    change24h: 2.4,
    description:
      'Bitcoin is the first and most widely recognized cryptocurrency, created by Satoshi Nakamoto in 2009. It operates on a decentralized network using blockchain technology.',
    website: 'https://bitcoin.org',
    whitepaper: 'https://bitcoin.org/bitcoin.pdf',
    pros: [
      'Most established cryptocurrency',
      'Highest liquidity',
      'Wide merchant acceptance',
      'Strong security track record',
    ],
    cons: [
      'High transaction fees during peak times',
      'Slower transaction speeds',
      'Energy-intensive mining',
    ],
    reviews: [
      {
        id: '1',
        author: 'CryptoTrader2024',
        rating: 5,
        date: '2024-01-15',
        comment: 'The gold standard of crypto. Reliable and trusted.',
        verified: true,
      },
      {
        id: '2',
        author: 'InvestorJohn',
        rating: 4,
        date: '2024-01-10',
        comment: 'Great store of value but fees can be high.',
        verified: true,
      },
    ],
  },
  {
    id: 'ethereum',
    name: 'Ethereum',
    symbol: 'ETH',
    rank: 2,
    trustScore: 9.3,
    price: 2280.5,
    marketCap: 274000000000,
    volume24h: 15200000000,
    change24h: 3.1,
    description:
      'Ethereum is a decentralized platform that enables smart contracts and decentralized applications (dApps) to be built and operated without downtime, fraud, or interference.',
    website: 'https://ethereum.org',
    pros: [
      'Smart contract functionality',
      'Large developer ecosystem',
      'Proof of Stake consensus',
      'NFT and DeFi leader',
    ],
    cons: [
      'Gas fees can be expensive',
      'Network congestion issues',
      'Complexity for beginners',
    ],
    reviews: [
      {
        id: '3',
        author: 'DeFiEnthusiast',
        rating: 5,
        date: '2024-01-14',
        comment: 'The backbone of DeFi. Incredible ecosystem.',
        verified: true,
      },
      {
        id: '4',
        author: 'SmartContractDev',
        rating: 5,
        date: '2024-01-12',
        comment: 'Best platform for building dApps.',
        verified: true,
      },
    ],
  },
  {
    id: 'binance-coin',
    name: 'Binance Coin',
    symbol: 'BNB',
    rank: 3,
    trustScore: 8.7,
    price: 315.2,
    marketCap: 47000000000,
    volume24h: 1800000000,
    change24h: 1.8,
    description:
      'Binance Coin is the native cryptocurrency of the Binance exchange, used for trading fee discounts and various utilities within the Binance ecosystem.',
    website: 'https://www.binance.com',
    pros: [
      'Trading fee discounts',
      'Strong exchange backing',
      'Growing ecosystem',
      'Regular token burns',
    ],
    cons: [
      'Centralized control',
      'Dependent on Binance success',
      'Regulatory scrutiny',
    ],
    reviews: [
      {
        id: '5',
        author: 'BinanceUser',
        rating: 4,
        date: '2024-01-13',
        comment: 'Great utility token for Binance users.',
        verified: true,
      },
    ],
  },
  {
    id: 'solana',
    name: 'Solana',
    symbol: 'SOL',
    rank: 4,
    trustScore: 8.5,
    price: 98.75,
    marketCap: 42000000000,
    volume24h: 2100000000,
    change24h: 5.2,
    description:
      'Solana is a high-performance blockchain supporting builders around the world creating crypto apps that scale.',
    website: 'https://solana.com',
    pros: [
      'Extremely fast transactions',
      'Low fees',
      'Growing DeFi ecosystem',
      'Strong developer community',
    ],
    cons: [
      'Network outages in the past',
      'Centralization concerns',
      'Relatively newer platform',
    ],
    reviews: [
      {
        id: '6',
        author: 'SpeedTrader',
        rating: 5,
        date: '2024-01-11',
        comment: 'Lightning fast and cheap. Love it!',
        verified: true,
      },
    ],
  },
  {
    id: 'cardano',
    name: 'Cardano',
    symbol: 'ADA',
    rank: 5,
    trustScore: 8.4,
    price: 0.52,
    marketCap: 18500000000,
    volume24h: 420000000,
    change24h: -0.8,
    description:
      'Cardano is a proof-of-stake blockchain platform founded on peer-reviewed research and developed through evidence-based methods.',
    website: 'https://cardano.org',
    pros: [
      'Academic research-based',
      'Energy efficient PoS',
      'Strong community',
      'Methodical development',
    ],
    cons: [
      'Slower development pace',
      'Limited dApp ecosystem',
      'Lower adoption than competitors',
    ],
    reviews: [
      {
        id: '7',
        author: 'AcademicInvestor',
        rating: 4,
        date: '2024-01-09',
        comment: 'Love the research-driven approach.',
        verified: true,
      },
    ],
  },
  {
    id: 'ripple',
    name: 'XRP',
    symbol: 'XRP',
    rank: 6,
    trustScore: 7.9,
    price: 0.58,
    marketCap: 31000000000,
    volume24h: 1200000000,
    change24h: 1.2,
    description:
      'XRP is a digital asset built for payments, offering fast and low-cost international money transfers.',
    website: 'https://ripple.com',
    pros: [
      'Fast settlement times',
      'Low transaction costs',
      'Banking partnerships',
      'High throughput',
    ],
    cons: [
      'Ongoing SEC lawsuit',
      'Centralization concerns',
      'Limited use cases outside payments',
    ],
    reviews: [
      {
        id: '8',
        author: 'BankingPro',
        rating: 4,
        date: '2024-01-08',
        comment: 'Great for cross-border payments.',
        verified: true,
      },
    ],
  },
  {
    id: 'polkadot',
    name: 'Polkadot',
    symbol: 'DOT',
    rank: 7,
    trustScore: 8.2,
    price: 7.35,
    marketCap: 9800000000,
    volume24h: 280000000,
    change24h: 2.9,
    description:
      'Polkadot enables cross-blockchain transfers of any type of data or asset, not just tokens.',
    website: 'https://polkadot.network',
    pros: [
      'Interoperability focus',
      'Parachain architecture',
      'Strong technical team',
      'Governance features',
    ],
    cons: [
      'Complex technology',
      'Competition from other chains',
      'Parachain auction costs',
    ],
    reviews: [
      {
        id: '9',
        author: 'InteropFan',
        rating: 5,
        date: '2024-01-07',
        comment: 'The future of blockchain interoperability.',
        verified: true,
      },
    ],
  },
  {
    id: 'dogecoin',
    name: 'Dogecoin',
    symbol: 'DOGE',
    rank: 8,
    trustScore: 7.2,
    price: 0.082,
    marketCap: 11700000000,
    volume24h: 580000000,
    change24h: -1.5,
    description:
      'Originally created as a joke, Dogecoin has become a popular cryptocurrency with a strong community.',
    website: 'https://dogecoin.com',
    pros: [
      'Strong community',
      'Low transaction fees',
      'Fast transactions',
      'Celebrity endorsements',
    ],
    cons: [
      'Unlimited supply',
      'Limited utility',
      'Meme-based volatility',
      'Less serious development',
    ],
    reviews: [
      {
        id: '10',
        author: 'MemeLord',
        rating: 3,
        date: '2024-01-06',
        comment: 'Fun community but risky investment.',
        verified: false,
      },
    ],
  },
  {
    id: 'avalanche',
    name: 'Avalanche',
    symbol: 'AVAX',
    rank: 9,
    trustScore: 8.3,
    price: 36.8,
    marketCap: 13500000000,
    volume24h: 520000000,
    change24h: 4.1,
    description:
      'Avalanche is a layer one blockchain that functions as a platform for decentralized applications and custom blockchain networks.',
    website: 'https://www.avax.network',
    pros: [
      'High throughput',
      'Low latency',
      'Ethereum compatibility',
      'Subnet architecture',
    ],
    cons: [
      'Newer platform',
      'Validator requirements',
      'Competition from established chains',
    ],
    reviews: [
      {
        id: '11',
        author: 'DeFiBuilder',
        rating: 5,
        date: '2024-01-05',
        comment: 'Impressive speed and low fees.',
        verified: true,
      },
    ],
  },
  {
    id: 'chainlink',
    name: 'Chainlink',
    symbol: 'LINK',
    rank: 10,
    trustScore: 8.6,
    price: 14.92,
    marketCap: 8300000000,
    volume24h: 380000000,
    change24h: 0.7,
    description:
      'Chainlink is a decentralized oracle network that enables smart contracts to securely interact with real-world data.',
    website: 'https://chain.link',
    pros: [
      'Essential infrastructure',
      'Wide adoption',
      'Strong partnerships',
      'Proven technology',
    ],
    cons: [
      'Token utility questions',
      'Competition emerging',
      'Complex tokenomics',
    ],
    reviews: [
      {
        id: '12',
        author: 'OracleFan',
        rating: 5,
        date: '2024-01-04',
        comment: 'Critical infrastructure for DeFi.',
        verified: true,
      },
    ],
  },
]

export const exchanges: Exchange[] = [
  {
    id: 'binance',
    name: 'Binance',
    rank: 1,
    trustScore: 9.2,
    tradingVolume: 76000000000,
    supportedCoins: 350,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      "Binance is the world's largest cryptocurrency exchange by trading volume, offering a comprehensive suite of trading products and services.",
    website: 'https://www.binance.com',
    features: [
      'Spot trading',
      'Futures',
      'Staking',
      'NFT marketplace',
      'Launchpad',
      'P2P trading',
    ],
    pros: [
      'Highest liquidity',
      'Wide coin selection',
      'Low fees',
      'Advanced trading features',
      'Mobile app',
    ],
    cons: [
      'Regulatory challenges',
      'Complex for beginners',
      'Customer support issues',
      'Not available in all regions',
    ],
    reviews: [
      {
        id: '13',
        author: 'ProTrader',
        rating: 5,
        date: '2024-01-15',
        comment: 'Best exchange for serious traders. Unmatched liquidity.',
        verified: true,
      },
      {
        id: '14',
        author: 'CryptoNewbie',
        rating: 3,
        date: '2024-01-14',
        comment: 'Overwhelming at first but powerful once you learn it.',
        verified: true,
      },
    ],
  },
  {
    id: 'coinbase',
    name: 'Coinbase',
    rank: 2,
    trustScore: 9.0,
    tradingVolume: 28000000000,
    supportedCoins: 240,
    tradingFee: '0.5%',
    withdrawalFee: 'Varies by coin',
    description:
      'Coinbase is a publicly-traded US-based cryptocurrency exchange known for its user-friendly interface and regulatory compliance.',
    website: 'https://www.coinbase.com',
    features: [
      'Spot trading',
      'Staking',
      'NFTs',
      'Learning rewards',
      'Coinbase Card',
      'Advanced trading',
    ],
    pros: [
      'User-friendly',
      'Regulated and insured',
      'Strong security',
      'Educational resources',
      'Fiat on-ramps',
    ],
    cons: [
      'Higher fees',
      'Limited coin selection vs competitors',
      'Customer support delays',
      'Occasional outages',
    ],
    reviews: [
      {
        id: '15',
        author: 'BeginnerInvestor',
        rating: 5,
        date: '2024-01-13',
        comment: 'Perfect for getting started. Easy to use and trustworthy.',
        verified: true,
      },
      {
        id: '16',
        author: 'FeeConscious',
        rating: 3,
        date: '2024-01-12',
        comment: 'Great platform but fees add up quickly.',
        verified: true,
      },
    ],
  },
  {
    id: 'kraken',
    name: 'Kraken',
    rank: 3,
    trustScore: 8.9,
    tradingVolume: 12000000000,
    supportedCoins: 200,
    tradingFee: '0.16%',
    withdrawalFee: 'Varies by coin',
    description:
      'Kraken is a veteran cryptocurrency exchange known for its security, low fees, and comprehensive trading options.',
    website: 'https://www.kraken.com',
    features: [
      'Spot trading',
      'Futures',
      'Margin trading',
      'Staking',
      'OTC desk',
      'Banking services',
    ],
    pros: [
      'Strong security record',
      'Low fees',
      'Good customer support',
      'Regulated',
      'Advanced features',
    ],
    cons: [
      'Complex interface',
      'Slower fiat deposits',
      'Limited payment methods',
      'Verification process',
    ],
    reviews: [
      {
        id: '17',
        author: 'SecurityFirst',
        rating: 5,
        date: '2024-01-11',
        comment: "Most secure exchange I've used. Never been hacked.",
        verified: true,
      },
    ],
  },
  {
    id: 'bybit',
    name: 'Bybit',
    rank: 4,
    trustScore: 8.5,
    tradingVolume: 18000000000,
    supportedCoins: 300,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'Bybit is a derivatives-focused cryptocurrency exchange popular among traders for its advanced trading tools.',
    website: 'https://www.bybit.com',
    features: [
      'Derivatives',
      'Spot trading',
      'Copy trading',
      'Launchpad',
      'Earn products',
      'NFTs',
    ],
    pros: [
      'Excellent for derivatives',
      'High leverage options',
      'Good liquidity',
      'User-friendly interface',
    ],
    cons: [
      'Less regulated',
      'Primarily derivatives-focused',
      'Not available in US',
      'Newer platform',
    ],
    reviews: [
      {
        id: '18',
        author: 'FuturesTrader',
        rating: 5,
        date: '2024-01-10',
        comment: 'Best platform for futures trading. Clean interface.',
        verified: true,
      },
    ],
  },
  {
    id: 'okx',
    name: 'OKX',
    rank: 5,
    trustScore: 8.4,
    tradingVolume: 15000000000,
    supportedCoins: 340,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'OKX is a comprehensive cryptocurrency exchange offering spot, derivatives, and DeFi services.',
    website: 'https://www.okx.com',
    features: [
      'Spot trading',
      'Futures',
      'Options',
      'DeFi',
      'NFT marketplace',
      'Web3 wallet',
    ],
    pros: [
      'Wide product range',
      'Competitive fees',
      'Good liquidity',
      'Web3 integration',
    ],
    cons: [
      'Complex for beginners',
      'Regional restrictions',
      'Customer support issues',
    ],
    reviews: [
      {
        id: '19',
        author: 'DiverseTrader',
        rating: 4,
        date: '2024-01-09',
        comment: 'Great all-in-one platform for various crypto activities.',
        verified: true,
      },
    ],
  },
  {
    id: 'kucoin',
    name: 'KuCoin',
    rank: 6,
    trustScore: 8.2,
    tradingVolume: 9000000000,
    supportedCoins: 700,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'KuCoin is known as "The People\'s Exchange" offering a vast selection of cryptocurrencies and tokens.',
    website: 'https://www.kucoin.com',
    features: [
      'Spot trading',
      'Futures',
      'Margin',
      'P2P',
      'Staking',
      'Trading bots',
    ],
    pros: [
      'Huge coin selection',
      'Early access to new tokens',
      'Trading bots',
      'Competitive fees',
    ],
    cons: [
      'Less regulated',
      'Occasional liquidity issues',
      'Customer support',
      'Security concerns',
    ],
    reviews: [
      {
        id: '20',
        author: 'AltcoinHunter',
        rating: 4,
        date: '2024-01-08',
        comment: 'Best for finding new altcoins early.',
        verified: true,
      },
    ],
  },
  {
    id: 'gemini',
    name: 'Gemini',
    rank: 7,
    trustScore: 8.8,
    tradingVolume: 3500000000,
    supportedCoins: 70,
    tradingFee: '0.35%',
    withdrawalFee: 'Free (10 per month)',
    description:
      'Gemini is a regulated US cryptocurrency exchange founded by the Winklevoss twins, emphasizing security and compliance.',
    website: 'https://www.gemini.com',
    features: [
      'Spot trading',
      'Staking',
      'Gemini Earn',
      'Credit card',
      'Custody services',
      'ActiveTrader',
    ],
    pros: [
      'Highly regulated',
      'Strong security',
      'Free withdrawals',
      'Insurance coverage',
      'Good for institutions',
    ],
    cons: [
      'Higher fees',
      'Limited coin selection',
      'US-focused',
      'Smaller trading volume',
    ],
    reviews: [
      {
        id: '21',
        author: 'RegulationMatters',
        rating: 5,
        date: '2024-01-07',
        comment: 'Most trustworthy US exchange. Worth the higher fees.',
        verified: true,
      },
    ],
  },
  {
    id: 'bitfinex',
    name: 'Bitfinex',
    rank: 8,
    trustScore: 7.8,
    tradingVolume: 5000000000,
    supportedCoins: 150,
    tradingFee: '0.1%',
    withdrawalFee: 'Varies by coin',
    description:
      'Bitfinex is a veteran cryptocurrency exchange offering advanced trading features and high liquidity.',
    website: 'https://www.bitfinex.com',
    features: [
      'Spot trading',
      'Margin trading',
      'Derivatives',
      'Lending',
      'OTC',
      'Staking',
    ],
    pros: [
      'High liquidity',
      'Advanced features',
      'Margin trading',
      'Professional tools',
    ],
    cons: [
      'Past security issues',
      'Not available in US',
      'Complex interface',
      'Controversial history',
    ],
    reviews: [
      {
        id: '22',
        author: 'VeteranTrader',
        rating: 4,
        date: '2024-01-06',
        comment: 'Great for professional traders despite past issues.',
        verified: true,
      },
    ],
  },
  {
    id: 'gate-io',
    name: 'Gate.io',
    rank: 9,
    trustScore: 8.0,
    tradingVolume: 7000000000,
    supportedCoins: 1400,
    tradingFee: '0.15%',
    withdrawalFee: 'Varies by coin',
    description:
      'Gate.io offers one of the largest selections of cryptocurrencies and trading pairs in the industry.',
    website: 'https://www.gate.io',
    features: [
      'Spot trading',
      'Futures',
      'Copy trading',
      'Startup IEO',
      'Lending',
      'NFTs',
    ],
    pros: [
      'Massive coin selection',
      'Early token listings',
      'Competitive fees',
      'Multiple products',
    ],
    cons: [
      'Overwhelming interface',
      'Less regulated',
      'Customer support',
      'Lower liquidity on some pairs',
    ],
    reviews: [
      {
        id: '23',
        author: 'TokenCollector',
        rating: 4,
        date: '2024-01-05',
        comment: 'Incredible selection of coins. Can find anything here.',
        verified: true,
      },
    ],
  },
  {
    id: 'huobi',
    name: 'Huobi',
    rank: 10,
    trustScore: 7.9,
    tradingVolume: 4500000000,
    supportedCoins: 500,
    tradingFee: '0.2%',
    withdrawalFee: 'Varies by coin',
    description:
      'Huobi is a global cryptocurrency exchange offering comprehensive trading services and blockchain solutions.',
    website: 'https://www.huobi.com',
    features: [
      'Spot trading',
      'Futures',
      'Margin',
      'Staking',
      'DeFi',
      'Huobi Earn',
    ],
    pros: [
      'Established platform',
      'Wide coin selection',
      'Global presence',
      'Multiple products',
    ],
    cons: [
      'Regulatory challenges',
      'Declining volume',
      'Customer support',
      'Regional restrictions',
    ],
    reviews: [
      {
        id: '24',
        author: 'GlobalTrader',
        rating: 3,
        date: '2024-01-04',
        comment: 'Solid platform but facing regulatory headwinds.',
        verified: true,
      },
    ],
  },
]
